import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Photo } from '@models/photo';
import { Camera, CameraState, CameraStream, WebRTCCamera } from '@services/camera';
import { noop } from 'underscore';
import { CommonModule } from '@angular/common';
import { IconDirective } from '../../directives/icon.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-camera-feed',
  templateUrl: 'camera-feed.component.html',
  styleUrls: ['camera-feed.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, IconDirective, TranslateModule]
})
export class CameraFeedComponent implements OnInit, OnDestroy {
  private zone = inject(NgZone);

  @ViewChild('container', { static: true, read: ElementRef }) containerElement: ElementRef;

  @Input() facing = 'user';
  @Input() filename = 'capture.png';
  @Input() keepRunning = false;
  @Input() showCapture = true;
  @Input() cameraWidth = 640;
  @Input() cameraHeight = 480;

  @Output() capture = new EventEmitter<Photo>();

  CameraState = CameraState;
  stream: CameraStream;
  camera: Camera;

  get container(): HTMLElement {
    return this.containerElement.nativeElement;
  }

  ngOnInit() {
    this.camera = new WebRTCCamera(this.cameraWidth, this.cameraHeight);
    this.stream = this.camera.streamTo(this.container, noop, this.facing);
  }

  ngOnDestroy() {
    if (this.keepRunning) {
      return;
    }

    this.stream?.stop();
  }

  emit() {
    this.camera.snapBlob(this.stream).then((blob) => {
      this.zone.run(() => {
        const photo = new Photo(blob, this.filename);
        this.capture.emit(photo);
      });
    });
  }

  onCameraAction() {
    switch (this.camera.state) {
      case CameraState.Activated:
        this.emit();
        break;
      case CameraState.Loading:
      case CameraState.Deactivated:
      case CameraState.Uninitialized:
        this.stream = this.camera.streamTo(this.container, noop, this.facing);
        break;
    }
  }
}
